interface IAppDefinition {
    name: string;
    url: string;
    openInNewTab?: boolean;
}

export class AppDefinition implements IAppDefinition {
    public name: IAppDefinition['name'];
    public url: IAppDefinition['url'];
    public openInNewTab: IAppDefinition['openInNewTab'];

    constructor(props: IAppDefinition) {
        Object.assign(this, props);
    }
}
